import React from 'react'
import PropTypes from 'prop-types'

import { usePopper } from './use-popper'
import { MODIFIERS_DEFAULT } from './popover-utils'

const propTypes = {
    appendTo: PropTypes.string,
    arrowClassName: PropTypes.string,
    content: PropTypes.node,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    additionalModifiers: PropTypes.arrayOf(PropTypes.func),
    onTargetBlur: PropTypes.func,
    onTargetFocus: PropTypes.func,
    onTargetMouseEnter: PropTypes.func,
    onTargetMouseLeave: PropTypes.func,
    placement: PropTypes.string,
    smartPositionMod: PropTypes.bool
}

const defaultProps = {
    placement: 'bottom',
    modifiers: MODIFIERS_DEFAULT
}

/**
 * Popover component to easily use popper.js in React.
 * @author Andy Wermke
 * @example
 *     <Popover content='Some string or react element'>
 *         <div>Popover will be placed next to this DOM node.</div>
 *     </Popover>
 */
const Popover = ({
    additionalModifiers,
    appendTo,
    arrowClassName,
    children,
    className,
    content,
    modifiers,
    onTargetBlur,
    onTargetFocus,
    onTargetMouseEnter,
    onTargetMouseLeave,
    placement
}) => {
    const popperRef = usePopper(<div>{content}</div>, {
        isActive: !!content,
        appendToParent: appendTo === 'parent',
        arrowClassName,
        contentClassName: className,
        additionalModifiers,
        options: { modifiers, placement }
    })

    return (
        <div
            ref={popperRef}
            onFocus={onTargetFocus}
            onBlur={onTargetBlur}
            onMouseEnter={onTargetMouseEnter}
            onMouseLeave={onTargetMouseLeave}
        >
            {children}
        </div>
    )
}

Popover.propTypes = propTypes
Popover.defaultProps = defaultProps

export { Popover }
